import React from 'react'
import AdminIndexPage from './Admin/index.tsx'
import { auth } from './../store/auth'
import MainPage from './User/index'
import { observer } from 'mobx-react-lite'

export default observer(function SwitcPage() {
	if (auth.user.data.AVN20 === 1) {
		if (auth.user.data.AVN_BT_report === 1) {
			return <AdminIndexPage />
		}
		return <MainPage />
	}

	if (auth.user.data.AVN20 === 0) {
		return <MainPage />
	}

	return null
})

